import TourListingPage from "../components/tours/TourListingPage";

export default function CompletedToursPage() {
  return (
    <TourListingPage
      endpoint="past-tours"
      title="Completed Tours"
      description="Review your completed destinations, schedules, and travel history."
      icon="fa-plane-departure"
      emptyTitle="Completed Adventures"
      emptyMessage="No completed tours are available yet."
          badgeVisibility="false"
          
    />
  );
}
